import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {Impressum} from './Impressum/Impressum';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import { Datenschutz } from 'Impressum/Datenschutz';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
    <Routes>
      <Route path="/Imprint" element={<Impressum />} />
      <Route path="/DataProtection" element={<Datenschutz />} />

     <Route  path="/" element={<App />} />
    </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
